
  import { integrationsService } from '@/services/integrations/integrationsService';
  import { Integration } from '@/services/integrations/types';
  import Status from '../Status.vue';
  import { pushRoute } from '@/ui/helpers';
  import { defineComponent, ref } from 'vue';

  export default defineComponent({
    name: 'Integration',
    components: {
      Status,
    },
    props: {
      integration: {
        type: Object as () => Integration,
        required: true,
      },
    },
    setup(props) {
      const url = ref<string|null>(null);
      integrationsService.resolveAvatarUrl(props.integration).then(u => {
        url.value = u;
      });

      const openIntegration = () => {
        pushRoute({
          name: 'integrationDetails',
          params: { id: props.integration.id },
        });
      };

      return {
        isActivated: integrationsService.isActivated(props.integration),
        url,
        openIntegration,
      };
    },
  });
